import React, { PureComponent } from 'react';
import { Canvas, Image, StyleSheet, Text, View } from '@react-pdf/renderer';
import moment from 'moment/moment';

export class NetworkMap extends PureComponent<{ date: Date; map: string }> {
    render() {
        const formattedDate = moment(this.props.date).format('dddd, D MMMM YYYY');
        return (
            <View style={styles.container}>
                <Text style={styles.date}>{formattedDate}</Text>
                {this.props.map ? this.renderMap() : this.renderPlaceHolder()}
            </View>
        );
    }

    private renderMap() {
        return (
            <View>
                <View>
                    <Image source={this.props.map} />
                </View>
                <View style={styles.legend}>
                    <View style={styles.legendItem}>
                        <View style={{ paddingRight: 5 }}>
                            <Canvas paint={painter => painter.save().rect(0, 0, 10, 10).fill('grey')} />
                        </View>
                        <Text>Regulation</Text>
                    </View>
                    <View style={styles.legendItem}>
                        <View style={{ paddingRight: 5 }}>
                            <Canvas paint={painter => painter.save().rect(0, 0, 10, 10).fill('orange')} />
                        </View>
                        <Text>Weather</Text>
                    </View>
                    <View style={styles.legendItem}>
                        <View style={{ paddingRight: 5 }}>
                            <Canvas paint={painter => painter.save().rect(0, 0, 10, 10).fill('green')} />
                        </View>
                        <Text>Hotspots</Text>
                    </View>
                    <View style={styles.legendItem}>
                        <View style={{ paddingRight: 5 }}>
                            <Canvas paint={painter => painter.save().rect(0, 0, 10, 10).fill('red')} />
                        </View>
                        <Text>Network Summary</Text>
                    </View>
                    <View style={styles.legendItem}>
                        <View style={{ paddingRight: 5 }}>
                            <Canvas paint={painter => painter.save().rect(0, 0, 10, 10).fill('blue')} />
                        </View>
                        <Text>Other</Text>
                    </View>
                </View>
            </View>
        );
    }

    private renderPlaceHolder() {
        return (
            <Text style={{ fontSize: 15, justifyContent: 'center', padding: 10 }}>
                The network MAP image is not available.
            </Text>
        );
    }
}

const styles = StyleSheet.create({
    container: {
        paddingTop: 10,
        rowGap: 10,
    },
    date: {
        fontSize: 15,
    },
    legend: {
        flexDirection: 'row',
        alignSelf: 'center',
    },
    legendItem: {
        flexDirection: 'row',
        paddingRight: '10px',
        alignItems: 'center',
    },
});
